import service from '@/components/service/Service'
import ServicesList from '@/components/service/ServicesList'
import ServicesNew from '@/components/service/ServicesNew'
import ServicesEdit from '@/components/service/ServicesEdit'

export default [
  {
    path: '/serviceData',
    name: 'serviceData',
    component: service,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/servicesList',
    name: 'servicesList',
    component: ServicesList,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/servicesNew',
    name: 'servicesNew',
    component: ServicesNew,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/servicesEdit/:id',
    name: 'servicesEdit',
    component: ServicesEdit,
    meta: {
      requiresAuth: true
    }
  },
]



// WEBPACK FOOTER //
// ./src/router/serviceDataRoutes.js